import { StockExchange, ExchangeSetting } from '@g17eco/types/stock-exchange-settings';
import { g17ecoApi, transformResponse } from './g17ecoApi';

interface UpdateExchangeSettingsParams {
  initiativeId: string;
  exchangeSettings: ExchangeSetting[];
}

interface AddManualStockExchangeParams {
  initiativeId: string;
  name: string;
}

const STOCK_EXCHANGE_SETTINGS_TAG = 'stock-exchange-settings';

export const exchangeSettingsApi = g17ecoApi
  .enhanceEndpoints({
    addTagTypes: [STOCK_EXCHANGE_SETTINGS_TAG],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getListOfStockExchanges: builder.query<StockExchange[], void>({
        transformResponse,
        query: () => ({
          url: '/stock-exchange-settings/list',
          method: 'get',
        }),
        providesTags: [STOCK_EXCHANGE_SETTINGS_TAG],
      }),
      updateExchangeSettings: builder.mutation<ExchangeSetting[], UpdateExchangeSettingsParams>({
        transformResponse,
        query: ({ initiativeId, exchangeSettings }) => ({
          url: `/stock-exchange-settings/${initiativeId}`,
          method: 'patch',
          data: { exchangeSettings },
        }),
      }),
      addManualStockExchange: builder.mutation<ExchangeSetting[], AddManualStockExchangeParams>({
        transformResponse,
        query: ({ initiativeId, name }) => ({
          url: `/stock-exchange-settings/${initiativeId}`,
          method: 'post',
          data: { name },
        }),
      }),
    }),
  });

export const {
  useGetListOfStockExchangesQuery,
  useUpdateExchangeSettingsMutation,
  useAddManualStockExchangeMutation,
} = exchangeSettingsApi;
